/**
 * Campaign list item shape from GET /api/campaigns/list
 */
export const RESUMABLE_CAMPAIGN_STATUSES = ["aborted", "inactive", "failed", "cancelled"];

export function canResumeCampaign(status) {
  return RESUMABLE_CAMPAIGN_STATUSES.includes(String(status || "").toLowerCase());
}

export const EMPTY_CAMPAIGN_STATS = {
  sent: 0,
  delivered: 0,
  failed: 0,
  read: 0,
  replies: 0,
  pending: 0,
  total: 0,
  success_pct: 0,
  delivery_pct: 0,
  failure_pct: 0,
};

/**
 * Map list item → shape expected by campaign modals / actions.
 */
export function toModalCampaign(item) {
  if (!item) return null;
  return {
    campaign_id: item.campaign_id,
    campaign_name: item.campaign_name,
    status: item.status,
    phone_id: item.phone_id,
    phone_number: item.phone_number,
    whatsapp_account_id: item.whatsapp_account_id,
    scheduled_at: item.scheduled_at,
    scheduled_time_original: item.scheduled_time_original,
    timezone: item.timezone,
    error_message: item.error_message,
    updated_at: item.updated_at,
  };
}

export function getStatusBadge(status) {
  const badges = {
    completed: { bg: "bg-emerald-100", text: "text-emerald-700", dot: "bg-emerald-600", border: "border-emerald-200" },
    active: { bg: "bg-blue-100", text: "text-blue-700", dot: "bg-blue-600", border: "border-blue-200" },
    scheduled: { bg: "bg-purple-100", text: "text-purple-700", dot: "bg-purple-600", border: "border-purple-200" },
    cancelled: { bg: "bg-red-100", text: "text-red-700", dot: "bg-red-600", border: "border-red-200" },
    aborted: { bg: "bg-red-100", text: "text-red-700", dot: "bg-red-600", border: "border-red-200" },
    inactive: { bg: "bg-gray-100", text: "text-gray-700", dot: "bg-gray-600", border: "border-gray-200" },
    failed: { bg: "bg-red-100", text: "text-red-700", dot: "bg-red-600", border: "border-red-200" },
    preparing: { bg: "bg-amber-100", text: "text-amber-800", dot: "bg-amber-500", border: "border-amber-200" },
    pending: { bg: "bg-amber-100", text: "text-amber-700", dot: "bg-amber-600", border: "border-amber-200" },
  };
  return badges[status] || { bg: "bg-gray-100", text: "text-gray-700", dot: "bg-gray-600", border: "border-gray-200" };
}

export function getStatusTooltipContent(campaign) {
  const errorStatuses = ["inactive", "failed", "aborted"];
  const status = campaign?.status ? String(campaign.status).toLowerCase() : "";
  const updatedAt = campaign?.updated_at
    ? new Date(campaign.updated_at).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })
    : "N/A";
  const lines = [`Last updated: ${updatedAt}`];

  if (status === "preparing") {
    const prepared = Number(campaign.prepared_count) || 0;
    const total = campaign.preparation_total != null ? Number(campaign.preparation_total) : null;
    if (total) {
      lines.push(`Preparing audience: ${prepared.toLocaleString()} / ${total.toLocaleString()}`);
    } else {
      lines.push("Preparing audience in the background…");
    }
  }

  const msg = campaign.error_message;
  if (msg && String(msg).trim()) {
    lines.push(String(msg).trim());
  } else if (errorStatuses.includes(status)) {
    lines.push("Error: No error details");
  }
  return lines.join("\n");
}
